import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const faqs = [
  {
    q: "How do guests upload photos without an app?",
    a: "Our advanced QR technology triggers the native mobile browser's file picker. Guests simply scan, select their favorite photos or videos, and hit upload. It's instant."
  },
  {
    q: "Is the gallery private and secure?",
    a: "Absolutely. Kuhako.pro uses enterprise-grade encryption. You control the access, and we never sell your memories or data to third parties."
  },
  {
    q: "Does it support 4K video and high-res photos?",
    a: "Yes. Unlike social media platforms that compress your files, we preserve the original quality of every capture."
  },
  {
    q: "Can I use it for international events?",
    a: "Yes, Kuhako.pro is global. Our Geo-SEO optimization and multi-region servers ensure fast uploads from Tokyo to New York."
  }
];

export default function FAQ() {
  return (
    <section className="py-32 bg-zinc-950">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-sm font-black text-indigo-500 uppercase tracking-[0.3em] mb-4">AI Search Ready</h2>
          <h3 className="text-4xl font-black tracking-tighter">Your Questions, <span className="text-slate-500">Answered.</span></h3>
        </div>
        
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="glass-card rounded-2xl p-6 md:p-8 hover:border-indigo-500/50 transition-colors group">
              <h4 className="text-lg font-bold mb-4 flex items-center justify-between">
                {faq.q}
                <SafeIcon icon={FiIcons.FiPlus} className="text-indigo-500 group-hover:rotate-90 transition-transform" />
              </h4>
              <p className="text-slate-400 font-light leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}